// extracted by mini-css-extract-plugin
module.exports = {"b4tghaq":"b4tghaq"};